import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { of } from "rxjs";
import { tap } from "rxjs/operators";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})
export class InsuranceHubService {
     env = environment;
     private policyDetailsCache: any = null;
    constructor(private http: HttpClient) { }
    private policyDetailsRequest$ = null;
    GetUserPolicyListWithDetails() {
        this.policyDetailsCache = sessionStorage.getItem('UserPolicyDetails') ? JSON.parse(sessionStorage.getItem('UserPolicyDetails')) : null;
        if (this.policyDetailsCache && this.policyDetailsCache !== 'null') {
           
                return of(this.policyDetailsCache);
        }
        if (this.policyDetailsRequest$) {
            return this.policyDetailsRequest$;
        }
        this.policyDetailsRequest$ = this.http.post(this.env.webApiUrl + 'api/InsuranceHub/GetUserPolicyListWithDetails', null).pipe(
            tap(data => {
                this.policyDetailsCache = data;
                sessionStorage.setItem("UserPolicyDetails", JSON.stringify(data));
                this.policyDetailsRequest$ = null;
            })
        );
        return this.policyDetailsRequest$;
    }

    GetUserPolicyDetails(params: any) {
        return this.http.post(this.env.webApiUrl + 'api/InsuranceHub/GetUserPolicyDetails', params);
    }
    RequestCallBackEmail(params: any) {
    return this.http.post(this.env.webApiUrl + 'api/InsuranceHub/RequestCallBackEmail', params);
  }
  RequestCallBackFSLms(params: any) {
    return this.http.post(this.env.webApiUrl + 'api/InsuranceHub/RequestCallBackFsLms', params);
  }
}